import { useSyncExternalStore } from "react";
import { commandSignature } from "../../core";
import type { Command } from "../../core";
import { useRuntime } from "../runtime/RuntimeContext";

// Subscribe to the pending-flag of one command (signature). Re-renders only
// when THIS signature flips. Use the command-shape variant when the caller
// already builds a command object (and needs the rendered button to match
// what will actually be dispatched); use the signature-string variant when
// rendering before a payload exists (rare).
export function usePendingCommand(commandOrSignature: Command | string): boolean {
    const runtime = useRuntime();
    const signature = typeof commandOrSignature === "string"
        ? commandOrSignature
        : commandSignature(commandOrSignature);
    return useSyncExternalStore(
        (listener) => runtime.pendingCommands.subscribe(signature, listener),
        () => runtime.pendingCommands.has(signature),
        () => false, // SSR snapshot — nothing is ever pending on the server.
    );
}
